var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVector55(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 546,
    height: 18,
    viewBox: "0 0 546 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M176.5 3.36732C173.35 3.84061 157.78 3.36738 154 3.36738C149.275 3.36738 4.57825 3.00973 3.00329 11.5291C1.74333 18.3445 362.143 11.6019 543 11.3652",
    stroke: "#FCD34D",
    strokeWidth: 6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector55);
export default __webpack_public_path__ + "static/media/Vector 55.1d4cacd35b2fceef0b056e0f186abb70.svg";
export { ForwardRef as ReactComponent };